export default __webpack_public_path__ + "static/media/stolenGallery.82c69d1f.png";